import { client } from '../client';
import { Insurance } from './types/UserProfile';

export const removePatientInsurance = async (user_id?: number): Promise<Insurance> => {
  const { data } = await client.delete<Insurance>(`/insurances/current${user_id ? `?user_id=${user_id}` : ''}`);

  return data;
};
